export default __webpack_public_path__ + "static/media/poocoin-2.313cc223.png";